export default __webpack_public_path__ + "img/code-input-large.jpg";